'use client'

import { useMutation } from '@apollo/client'
import { Button, Label } from '@chain-zen/ui'

import { useWorkspaceSetup } from '../../contexts/setup-workspace-context'
import { REQUEST_CUSTOM_VERIFICATION } from '../../data/mutations/workspace'
import { useSetupWorkspaceModal } from '../../stores/setup-workspace-modal-store'
import { SetupWorkspaceLayout } from './setup-workspace-layout'

/**
 * This component is used to request a custom verification
 */
export const RequestCustomVerification = () => {
  const { setStep, companyIdentifierType, companyIdentifierValue } = useWorkspaceSetup()
  const { workspaceID } = useSetupWorkspaceModal()

  const [requestCustomVerification, { loading }] = useMutation(REQUEST_CUSTOM_VERIFICATION, {
    onCompleted: () => {
      setStep(10) // Setting the step to 10 will trigger the next step in the setup process which is the ConfirmationStep component.
    }
  })

  const handleSubmit = async () => {
    await requestCustomVerification({
      context: {
        headers: {
          'ws-id': workspaceID || ''
        }
      },
      variables: {
        input: {
          companyIdentifier: {
            type: companyIdentifierType,
            value: companyIdentifierValue
          }
        }
      }
    })
  }

  return (
    <SetupWorkspaceLayout
      title="Request Custom Verification"
      footer={{
        label: 'Go back',
        onClick: () => setStep(5) // Setting the step to 5 will trigger the previous step in the setup process which is the SelectVerificationMethod component.
      }}
    >
      <Label>Are you sure you want to request a custom verification?</Label>
      <Button onClick={handleSubmit} className="w-full mt-4" loading={loading}>
        Request verification
      </Button>
    </SetupWorkspaceLayout>
  )
}
